// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vMTy","right":"Footer_right__2pNAo","buttons":"Footer_buttons__3J3Mn"};